var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { DataTypeOperator } from "../../../models/audience/filter.model";
import { convertLocalDateToDate, formatDateLocalISO } from "../../../utils/date.util";
import CDatePicker from "../../CDatePicker";
export var FilterDateInput = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var operator = _a.operator, filterRow = _a.filterRow, setFilterRow = _a.setFilterRow, type = _a.type;
    var content = null;
    switch (operator) {
        case DataTypeOperator.EQUAL:
        case DataTypeOperator.NOT_EQUAL:
        case DataTypeOperator.MORE_THAN:
        case DataTypeOperator.MORE_THAN_EQUAL:
        case DataTypeOperator.LESS_THAN:
        case DataTypeOperator.LESS_THAN_EQUAL:
            content = (_jsx(Box, __assign({ sx: { width: '100%', minWidth: 200 } }, { children: _jsx(CDatePicker, { value: type === 'timestamp' ? (_b = filterRow.timestampValues) === null || _b === void 0 ? void 0 : _b[0] : convertLocalDateToDate((_c = filterRow.localDateValues) === null || _c === void 0 ? void 0 : _c[0]), dateOnly: type === 'localDate', onChange: function (e) {
                        switch (type) {
                            case "timestamp":
                                setFilterRow(__assign(__assign({}, filterRow), { timestampValues: [e] }));
                                break;
                            case "localDate":
                                setFilterRow(__assign(__assign({}, filterRow), { localDateValues: [formatDateLocalISO(e)] }));
                                break;
                        }
                    } }) })));
            break;
        case DataTypeOperator.BETWEEN:
        case DataTypeOperator.NOT_BETWEEN:
        case DataTypeOperator.PERIOD_BETWEEN:
        case DataTypeOperator.PERIOD_NOT_BETWEEN:
        case DataTypeOperator.RECURRING_MONTH_BETWEEN:
        case DataTypeOperator.RECURRING_MONTH_NOT_BETWEEN:
            var isPeriodOperator = operator === DataTypeOperator.PERIOD_BETWEEN || operator === DataTypeOperator.PERIOD_NOT_BETWEEN
                || operator === DataTypeOperator.RECURRING_MONTH_BETWEEN || operator === DataTypeOperator.RECURRING_MONTH_NOT_BETWEEN;
            // Step 3.0 — RECURRING_MONTH_* stores its bounds as longValues = [month*100+day,
            // month*100+day]. The UI keeps reusing the dayMonthOnly date picker, but the
            // value adapter encodes/decodes the long form on either side of the picker.
            var isRecurringMonth_1 = operator === DataTypeOperator.RECURRING_MONTH_BETWEEN || operator === DataTypeOperator.RECURRING_MONTH_NOT_BETWEEN;
            var decodeMonthDay = function (md) {
                if (md == null)
                    return undefined;
                var month = Math.floor(md / 100);
                var day = md % 100;
                if (month < 1 || month > 12 || day < 1 || day > 31)
                    return undefined;
                var year = new Date().getFullYear();
                return new Date(year, month - 1, day);
            };
            var encodeMonthDay_1 = function (d) {
                if (!d)
                    return undefined;
                return (d.getMonth() + 1) * 100 + d.getDate();
            };
            content = (_jsxs(Stack, __assign({ direction: 'row', gap: 0.5, alignItems: 'center', sx: { width: '100%', minWidth: 200 } }, { children: [_jsx(Box, __assign({ sx: { flex: 1 } }, { children: _jsx(CDatePicker, { dateOnly: type === 'localDate', dayMonthOnly: isPeriodOperator, value: isRecurringMonth_1
                                ? decodeMonthDay((_d = filterRow.longValues) === null || _d === void 0 ? void 0 : _d[0])
                                : (type === 'timestamp' ? (_e = filterRow.timestampValues) === null || _e === void 0 ? void 0 : _e[0] : convertLocalDateToDate((_f = filterRow.localDateValues) === null || _f === void 0 ? void 0 : _f[0])), onChange: function (e) {
                                var _a, _b, _c;
                                if (isRecurringMonth_1) {
                                    setFilterRow(__assign(__assign({}, filterRow), { longValues: [encodeMonthDay_1(e), (_a = filterRow.longValues) === null || _a === void 0 ? void 0 : _a[1]] }));
                                    return;
                                }
                                switch (type) {
                                    case "timestamp":
                                        setFilterRow(__assign(__assign({}, filterRow), { timestampValues: [e, (_b = filterRow.timestampValues) === null || _b === void 0 ? void 0 : _b[1]] }));
                                        break;
                                    case "localDate":
                                        setFilterRow(__assign(__assign({}, filterRow), { localDateValues: [formatDateLocalISO(e), (_c = filterRow.localDateValues) === null || _c === void 0 ? void 0 : _c[1]] }));
                                        break;
                                }
                            } }) })), _jsx(Typography, { children: "-" }), _jsx(Box, __assign({ sx: { flex: 1 } }, { children: _jsx(CDatePicker, { dateOnly: type === 'localDate', dayMonthOnly: isPeriodOperator, value: isRecurringMonth_1
                                ? decodeMonthDay((_g = filterRow.longValues) === null || _g === void 0 ? void 0 : _g[1])
                                : (type === 'timestamp' ? (_h = filterRow.timestampValues) === null || _h === void 0 ? void 0 : _h[1] : convertLocalDateToDate((_j = filterRow.localDateValues) === null || _j === void 0 ? void 0 : _j[1])), onChange: function (e) {
                                var _a, _b, _c;
                                if (isRecurringMonth_1) {
                                    setFilterRow(__assign(__assign({}, filterRow), { longValues: [(_a = filterRow.longValues) === null || _a === void 0 ? void 0 : _a[0], encodeMonthDay_1(e)] }));
                                    return;
                                }
                                switch (type) {
                                    case "timestamp":
                                        setFilterRow(__assign(__assign({}, filterRow), { timestampValues: [(_b = filterRow.timestampValues) === null || _b === void 0 ? void 0 : _b[0], e] }));
                                        break;
                                    case "localDate":
                                        setFilterRow(__assign(__assign({}, filterRow), { localDateValues: [(_c = filterRow.localDateValues) === null || _c === void 0 ? void 0 : _c[0], formatDateLocalISO(e)] }));
                                        break;
                                }
                            } }) }))] })));
    }
    return content;
};
